var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a7-dashboard',{staticClass:"a7-dashboard-geral"},_vm._l((_vm.cards),function(card){return _c('a7-dashlet-visao-evolucao',{key:card.descricao,attrs:{"titulo":card.descricao,"medidas":card.medidas,"tipo":card.tipo}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }